// setPrivateShowTimer.js
'use strict';
import {
  MERGE_LIVE_STREAM_DATA,
  SET_LIVE_STREAM_DATA,
  MERGE_OPERATION_DATA,
} from '../ActionTypes.js';
import {
  SHOW_FUNDING_END_COUNTDOWN,
  SHOW_HESITATE_COUNTDOWN,
} from '../RemoteConfigKeys.js';
import addModal from '../action/addModal.js';
import closeModalAfterSeconds from '../action/closeModalAfterSeconds.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getGoalData from '../selector/getGoalData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getOperationData from '../selector/getOperationData.js';
import { privateShowTimerType } from '../resource/liveStreamConstants.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';

const AUTO_CLOSE_SHOW_POP_UP_SECONDS = 6; // TODO: remote config

/**
 * Set private show timer
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {string} {timerType} - timer type.
 * @return {Promise} Action promise.
 */
const setPrivateShowTimer =
  ({ streamId, timerType }) =>
  async (dispatch, getState) => {
    let timerId;
    const timestampOffsetSeconds = getTimestampOffset(
      getState(),
      Accuracy.SECOND
    );
    const now = getCurrentUnixTimestamp({
      offsetSeconds: timestampOffsetSeconds,
    });
    if (timerType === privateShowTimerType.TO_FUNDING_FINAL_CALL) {
      const fundingId = getLiveStreamData(
        getState(),
        [streamId, 'privateShow'],
        'fundingId'
      );
      const fundingExp = getGoalData(getState(), [fundingId], 'exp');
      const countdownSeconds = getRemoteConfigData(
        getState(),
        SHOW_FUNDING_END_COUNTDOWN
      );
      timerId = setTimeout(
        () => {
          dispatch({
            type: MERGE_OPERATION_DATA,
            payload: {
              selectPath: ['timer', 'livestream', streamId],
              data: {
                privateShow: null,
              },
            },
          });
          const activeStreamId = getOperationData(
            getState(),
            ['liveStream'],
            'activeStreamId'
          );
          if (activeStreamId === streamId) {
            dispatch(
              addModal({
                id: 'LiveStreamPrivateShowPopup',
              })
            );
            dispatch(
              closeModalAfterSeconds({
                modalId: 'LiveStreamPrivateShowPopup',
                seconds: Math.min(
                  AUTO_CLOSE_SHOW_POP_UP_SECONDS,
                  fundingExp - now
                ),
              })
            );
          }
          dispatch({
            type: MERGE_LIVE_STREAM_DATA,
            payload: {
              selectPath: [streamId, 'privateShow', 'status'],
              data: {
                isFundingFinalCall: true,
              },
            },
          });
        },
        (fundingExp - countdownSeconds - now) * 1000
      );
    } else if (timerType === privateShowTimerType.TO_REFUNDING) {
      const fundingId = getLiveStreamData(
        getState(),
        [streamId, 'privateShow'],
        'fundingId'
      );
      const expireUnixTimestamp = getGoalData(getState(), [fundingId], 'exp');
      const hesitationCountdownSeconds =
        getGoalData(
          getState(),
          [fundingId, 'context'],
          'hesitation_countdown'
        ) || getRemoteConfigData(getState(), SHOW_HESITATE_COUNTDOWN);
      timerId = setTimeout(
        () => {
          dispatch({
            type: MERGE_OPERATION_DATA,
            payload: {
              selectPath: ['timer', 'livestream', streamId],
              data: {
                privateShow: null,
              },
            },
          });
          dispatch({
            type: MERGE_LIVE_STREAM_DATA,
            payload: {
              selectPath: [streamId, 'privateShow', 'status'],
              data: {
                isRefunding: true,
              },
            },
          });
          dispatch(
            setPrivateShowTimer({
              streamId,
              timerType: privateShowTimerType.TO_IDLE,
            })
          );
        },
        (expireUnixTimestamp - now + hesitationCountdownSeconds || 0) * 1000
      );
    } else if (timerType === privateShowTimerType.TO_IDLE) {
      timerId = setTimeout(() => {
        dispatch({
          type: MERGE_OPERATION_DATA,
          payload: {
            selectPath: ['timer', 'livestream', streamId],
            data: {
              privateShow: null,
            },
          },
        });
        dispatch({
          type: SET_LIVE_STREAM_DATA,
          payload: {
            selectPath: [streamId, 'privateShow'],
            data: {},
          },
        });
      }, 5000); // TODO: remote config
    }
    if (!timerId) {
      return dispatch({ type: '' });
    }
    const existedTimerId = getOperationData(
      getState(),
      ['timer', 'livestream', streamId],
      'privateShow'
    );
    clearTimeout(existedTimerId);
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['timer', 'livestream', streamId],
        data: {
          privateShow: timerId,
        },
      },
    });
  };

export default setPrivateShowTimer;
